import { useQuery } from '@tanstack/react-query';
import { documentApiClient } from 'src/api/FiretrolApiClientInstances';
import { queryKeys } from 'src/api/queries/queryKeys';
import { toCancelToken } from 'src/api/queries/queryClient';

/** @registry Documents directly inside one folder of a job's document tree. */
export function useDocumentsInFolder(
  jobId: number | null | undefined,
  folderId: string | null | undefined,
) {
  return useQuery({
    queryKey: queryKeys.documents.inFolder(jobId ?? -1, folderId ?? ''),
    queryFn: ({ signal }) =>
      documentApiClient.listDocumentsInFolder(
        jobId!,
        folderId!,
        toCancelToken(signal),
      ),
    enabled: jobId != null && jobId > 0 && !!folderId,
    meta: { errorContext: 'folder documents' },
  });
}
